import type { TFunction } from 'i18next'
import type { TaskCascade } from '@/src/renderer/lib/db/models'

type Translate = (key: string, options?: { count?: number; list?: string }) => string

/**
 * **Was beim Löschen mitging** — die zweite Zeile unter „„Regal bauen“ gelöscht“ (#223):
 * „Mit 3 Unteraufgaben, 2 Kommentaren und 1 Erinnerung.“ Ging nichts mit, kein Text.
 * Die Fokuszeit zählt nicht: Sie sieht man nicht an der Aufgabe.
 */
export function cascadeDescription(cascade: TaskCascade, t: TFunction | Translate, locale: string): string | undefined {
  const translate = t as Translate
  const parts = ([
    ['subtasks', cascade.subtaskIds.length],
    ['comments', cascade.commentIds.length],
    ['reminders', cascade.reminderIds?.length ?? 0],
  ] as const)
    .filter(([, count]) => count > 0)
    .map(([kind, count]) => translate(`taskItem.cascade.${kind}`, { count }))
  if (parts.length === 0) return undefined
  const list = new Intl.ListFormat(locale, { type: 'conjunction' }).format(parts)
  return translate('taskItem.deletedWith', { list })
}
